var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"ax-navigation",class:{ row: !_vm.isElectron }},[_c('div',{class:{ col: !_vm.isElectron, 'navigation-content': _vm.isElectron }},[_c('AxNavigationBreadcrumbs',{attrs:{"items":_vm.breadcrumbs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }